<template>
  <el-table
    :data="data"
    @selection-change="handleSelectionChange"
    :empty-text="emptyText"
    style="width: 100%;">
    <el-table-column
      v-if="selection"
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      label="Produit"
      width="200">
      <template slot-scope="props">
        <span v-if="props.row.product">
          <el-link
            type="primary"
            @click="openProductDrawer(props.row)">
            {{props.row.product.sku}}
        </el-link>
        </span>
        <i v-else class="mdi mdi-alert " style="color:#EC205F;font-size:20px;"></i>
      </template>
    </el-table-column>
    <el-table-column
      prop="item.reference"
      label="Item"
      width="200">
    </el-table-column>
    <el-table-column
      label="Description">
      <template slot-scope="props">
        <span style="word-break:break-word;">{{props.row.description}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="qty"
      label="Qte. avant"
      width="90">
    </el-table-column>
    <el-table-column
      prop="new_qty"
      label="Qte. après"
      width="90">
    </el-table-column>
    <el-table-column
      prop="diff"
      label="Ajustement"
      width="100">
    </el-table-column>
    <el-table-column
      label="Commentaires" :show-overflow-tooltip="true">
      <template slot-scope="props">
        <span v-for="(error,index) in props.row.error" :key="index" style="word-break:break-word;">
          <i class="mdi mdi-alert " :style="commentaryStyle"></i>
          {{error}}
          <br v-if="index!=props.row.error.length"/>
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>

export default {
  name: 'Reconciliation-table',
	props: {
    data : {
      type : Array,
      require : true
    },
    error : {
      type : String,
      defaultValue : 'error'
    },
    selection : {
      type : Boolean,
      defaultValue : 'false'
    },
    emptyText : {
      type: String,
      defaultValue: 'Aucune données'
    }
	},
  data() {
    return {
      multipleSelection : [],
    };
  },components: {

  },
	methods: {
      openProductDrawer(product){
        this.$emit('openProduct', product.puid);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.$emit('selectionChanged', val);
      }
	},
	computed: {
    commentaryStyle(){
      if(this.error=="error"){
        return "color:#EC205F;font-size:20px;";
      }else{
        return "color:#F7BA2A;font-size:20px;";
      }

    }
	}
}
</script>
<style lang="scss" >




</style>
